import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { ActivatedRoute } from '@angular/router';
import { CategoryStockService } from 'src/app/home/services/category-stock.service';

@Component({
  selector: 'app-category-stocks',
  templateUrl: './category-stocks.component.html',
  styleUrl: './category-stocks.component.scss'
})

export class CategoryStocksComponent implements OnInit{

  public chartData: any;
  public warningMessage: string = "";

  constructor(private route: ActivatedRoute, private categoryStockService: CategoryStockService){}

  ngOnInit(): void {
    this.categoryStockService.getChartData().subscribe({
      next: (res) => {
        this.chartData = res.data;
        this.generateChart();
      },
      error: (e) => console.error(e),
      complete: () => console.info('complete') 
    }
    );
  }

  generateChart(): void {
    const container = document.getElementById('chartContainer');
    const chartData = this.chartData;
  
    if (!chartData || chartData.datasets.length === 0 || chartData.labels.length === 0) {
      this.warningMessage = "No stock available at this moment to view";
      return;
    }

    this.warningMessage = "";

    const ctx = document.getElementById('donutChart') as HTMLCanvasElement;

    const total = chartData.datasets.reduce((acc: number, dataset: any) => acc + dataset.data.reduce((subAcc: number, value: number) => subAcc + value, 0), 0);
  
    const chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartData.labels,
        datasets: chartData.datasets.map(dataset => ({
          label: dataset.label,
          data: dataset.data,
          backgroundColor: ['#35B5D4', '#24B946', '#FFCB46', '#43C6AE', '#FF872F'],
          hoverOffset: 4
        }))   
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
          },
          datalabels: {
            color: '#000000',
            formatter: (value: number, context: any) => {
              const percentage = (value / total) * 100;
              return `${Math.round(percentage)}%`;
            },
            anchor: 'end',
            align: 'start',
            offset: 0,
            font: {
              size: 16
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      plugins: [ChartDataLabels],
    });
  
    // Create legend
    const legendContainer = document.getElementById('legend');
    if (legendContainer) {
      legendContainer.innerHTML = ''; // Clear existing content
      chart.data.labels.forEach((label: string, index: number) => {
        const backgroundColor = chart.data.datasets[0].backgroundColor[index];
        const legendItem = document.createElement('div');
        legendItem.innerHTML = `
          <div class="legend-item" style="display: flex;margin-bottom:5px">
            <div class="bg-legend><div class="legend-color" style="background-color: ${backgroundColor}; width: 20px; height: 20px; border-radius: 50%;margin-right: 5px"></div></div>
            <div class="label-conetnt"><div class="legend-content"><span class="legend-label" style="font-size: 15px">${label}: ${chart.data.datasets[0].data[index]}</span></div></div>
            
          </div>
        `;
        legendContainer.appendChild(legendItem);
      });
      legendContainer.style.flex = ''; // Remove width
    }
  }

}
 